export const INSPECTION_STATE = {
	SENT: 'En trámite',
	RETURN: 'Devuelta',
	DERIVE: 'Derivado',
	REJECTED: 'Rechazado',
	APPROVED: 'Aprobado',
	PRESENCIAL: 'Presencial',
	DRAFT: 'Borrador',
	CREATE: 'Creado',
	CANCEL: 'Cancelado'
};

export const INSPECTION_STATE_COLOR = {
	CREATE: {
		color: 'text-gray',
		text: 'Creado'
	},	
	PRESENCIAL: {
		color: 'text-gray',
		text: 'Presencial'
	},
	DRAFT: {
		color: 'text-gray',
		text: 'Borrador'
	},
	DERIVE: {
		color: 'text-orange',
		text: 'Observada'
	},
	RETURN: {
		color: 'text-lg',
		text: 'Devuelta'
	},
	APPROVED: {
		color: 'text-green',
		text: 'Aprobado'
	},
	REJECTED: {
		color: 'text-red',
		text: 'Rechazado'
	},
	SENT: {
		color: 'text-orange',
		text: 'En trámite'
	},
	CANCEL: {
		color: 'text-red',
		text: 'Cancelado'
	}
};

export const INSPECTION_STATE_CODE = {
	DRAFT: 'DRAFT',
	CREATE: 'CREATE',
	SENT: 'SENT',
	RETURN: 'RETURN',
	DERIVE: 'DERIVE',
	REJECTED: 'REJECTED',
	APPROVED: 'APPROVED',
	PRESENCIAL: 'PRESENCIAL',
	CANCEL: 'CANCEL'
};

export const INSPECTION_STATES = [
	{id: 'DERIVE', label: 'Observada'},
	{id: 'SENT', label: 'En trámite'},
	{id: 'RETURN', label: 'Devuelta'},
	{id: 'PRESENCIAL', label: 'Presencial'},
	{id: 'REJECTED', label: 'Rechazada'},
	{id: 'APPROVED', label: 'Aprobada'},
	{id: 'DRAFT', label: 'Borrador'},
	{id: 'CREATE', label: 'Creado'},
	{id: 'CANCEL', label: 'Cancelado'}
];

export const SEARCH_INSPECTIONS_INPUTS = [
	{ id: 'POLICY_NUMBER', label: 'Póliza' },
	{ id: 'VEHICLE_CHASIS', label: 'Chasis' },
	{ id: 'VEHICLE_PLATE', label: 'Placa' },
	{ id: 'VEHICLE_MOTOR', label: 'Motor' }
];

export const INSPECTION_STATES_AUX = [
	{id: 'DRAFT', label: 'Borrador', icon: '', color: ''},
	{id: 'SENT', label: 'En trámite', icon: 'icon-state-inprocess', color: 'text-orange'},
	{id: 'RETURN', label: 'Devuelta', icon: 'icon-state-returned', color: 'text-gray'},
	{id: 'DERIVE', label: 'Observada', icon: 'icon-state-inprocess', color: 'text-orange'},
	{id: 'REJECTED', label: 'Rechazado', icon: 'icon-state-reject', color: 'text-red'},
	{id: 'APPROVED', label: 'Aprobado', icon: 'icon-state-approved', color: 'text-green'}
];

export const MESSAGES_NOTIFY = {
	MESSAGE_SUCCESSFULLY: 'El comentario se guardó con éxito!',
	MESSAGE_SAVE_GENERAL_COMMENT_SUCCESSFULLY: 'Comentario se guardó exitosamente.',
	MESSAGE_WITHOUT_COMMENT: 'El comentario no se guardó satisfactoriamente. Inténtalo nuevamente.',
	MESSAGE_ERROR_SAVE_COMMENT: 'Por favor, ingresa un comentario sobre el daño reportado',
	MESSAGE_APPROVED: 'La inspección se aprobó exitosamente',
	MESSAGE_RETURNED: 'La inspección se devolvió exitosamente',
	MESSAGE_DERIVED: 'La inspección se derivó a suscripción exitosamente',
	MESSAGE_ERROR_REASON_DERIVED: 'Debe seleccionar uno o más para derivar la inspección.',
	MESSAGE_REJECTED: 'La inspección fue rechazada exitosamente.',
	MESSAGE_ERROR_REASON_REJECTED: 'Debe seleccionar uno o más para rechazar la inspección.',
	MESSAGE_TO_PRESENCIAL_ERROR: 'La inspección no se envió a presencial exitosamente, inténtalo nuevamente.',
	MESSAGE_TO_PRESENCIAL: 'La inspección se envió a presencial exitosamente',
	MESSAGE_TO_GET_REPORT_INSPECTIONS: 'El reporte de inspecciones ya está descargado con éxito.',
	MESSAGE_TO_GET_REPORT_INSPECTIONS_ERROR: 'El reporte de inspecciones no se pudo descargar, inténtalo nuevamente.',
	MESSAGE_TO_CREATED: 'La inspección fue regresada a su estado inicial exitosamente.',
	MESSAGE_TO_CREATED_ERROR: 'No se pudo regresar al estado inicial de la inspección, inténtalo nuevamente.',
	MESSAGE_TO_RETURN: 'La inspección fue regresada a su estado devuelto exitosamente.',
	MESSAGE_TO_RETURN_ERROR: 'No se pudo regresar al estado Devuelto de la inspección, inténtalo nuevamente.',
	MESSAGE_TO_UPDATE: 'La inspección fue actualizada correctamente.',
	MESSAGE_TO_UPDATE_ERROR: 'No se pudo realizar la actualización de la inspección.',
	MESSAGE_TO_REMOVE: 'La inspección ha sido eliminada correctamente.',
	MESSAGE_TO_REMOVE_ERROR: 'No se pudo eliminar la inspección, intentalo nuevamente.'
};

export const CONFIG_NOTIFY = {
	position: "bottom-right",
	autoClose: 3000,
	hideProgressBar: false,
	closeOnClick: true,
	pauseOnHover: true
};

export const IMAGE_OBSERVATIONS = [
	{
		id: '001',
		label: 'Está muy oscura'
	},
	{
		id: '002',
		label: 'No corresponde a la parte'
	},
	{
		id: '003',
		label: 'No pertenece al auto'
	},
	{
		id: '004',
		label: 'Está cortada, no se ve la totalidad de la parte del auto'
	},
	{
		id: '005',
		label: 'El motor está apagado, debe estar encendido'
	},
	{
		id: '006',
		label: 'Llanta de repuesto está fuera del sitio apropiado'
	},
	{
		id: '007',
		label: 'Está borrosa'
	}
];

export const CATEGORIES_PICTURES = [
	{
		id: 'PICTURE',
		label: 'Generales'
	},
	{
		id: 'DAMAGE',
		label: 'Daños'
	},
	{
		id: 'ACCESSORY',
		label: 'Accesorios'
	}
];

export const FILES_NAMES = [
	{
		id: 'OWNER_CARD_FRONT',
		label: 'Tarjeta de propiedad - Frontal'
	},
	{
		id: 'OWNER_CARD_BACK',
		label: 'Tarjeta de propiedad - Posterior'
	},
	{
		id: 'FRONT',
		label: 'Foto frontal'
	},
	{
		id: 'BACK',
		label: 'Foto posterior'
	},
	{
		id: 'LEFT',
		label: 'Lateral del piloto'
	},
	{
		id: 'RIGHT',
		label: 'Lateral del copiloto'
	},
	{
		id: 'UP',
		label: 'Techo'
	},
	{
		id: 'TIRE',
		label: 'Llanta y aro'
	},
	{
		id: 'SPARE_TIRE',
		label: 'Llanta de repuesto'
	},
	{
		id: 'TRUNK',
		label: 'Maletera abierta'
	},
	{
		id: 'BOARD_ON',
		label: 'Tablero encendido'
	},
	{
		id: 'BOARD_RUDDER',
		label: 'Tablero y timón'
	},
	{
		id: 'RADIO_LEVER',
		label: 'Radio y palanca'
	},
	{
		id: 'MOTOR',
		label: 'Motor'
	},
	{
		id: 'CHASSIS_NUMBER',
		label: 'Número de chasis'
	},
	{
		id: 'TIRE_FRONT_RIGHT',
		label: 'Llanta delantera copiloto'
	},
	{
		id: 'TIRE_FRONT_LEFT',
		label: 'Llanta delantera piloto'
	},
	{
		id: 'TIRE_BACK_RIGHT',
		label: 'Llanta posterior copiloto'
	},
	{
		id: 'TIRE_BACK_LEFT',
		label: 'Llanta posterior piloto'
	},
	{
		id: 'RADIO',
		label: 'Radio'
	},
	{
		id: 'COMPONENTS',
		label: 'Componentes'
	},
	{
		id: 'AMPLIFIERS',
		label: 'Amplificadores'
	},
	{
		id: 'SPEAKERS',
		label: 'Parlantes'
	},
	{
		id: 'EQUALIZERS',
		label: 'Ecualizadores'
	},
	{
		id: 'SUBWOOFER',
		label: 'Subwoofers'
	},
	{
		id: 'WHEEL',
		label: 'Llantas'
	},
	{
		id: 'RIM',
		label: 'Aros'
	}
];

export const DERIVATIONS_REASONS = [
	{
		id: '001',
		label: 'Tarjeta no coincide con auto'
	},
	{
		id: '002',
		label: 'Daños graves'
	},
	{
		id: '003',
		label: 'Tiene jaula'
	},
	{
		id: '004',
		label: 'Kilometraje mayor a 300,000'
	},
	{
		id: '005',
		label: 'Uso no declarado'
	},
	{
		id: '006',
		label: 'Ha sido pérdida total'
	},
	{
		id: '007',
		label: 'No asegurable'
	},
	{
		id: '008',
		label: 'Timón cambiado'
	},
	{
		id: '009',
		label: 'Versión coreana / americana'
	}
];

export const FILES_NAMES_DAMAGES = [	
	{
		id: 'FRONT',
		label: 'Zona delantera'
	},
	{
		id: 'BACK',
		label: 'Zona posterior'
	},
	{
		id: 'RIGHT',
		label: 'Lado del copiloto'
	},
	{
		id: 'LEFT',
		label: 'Lado del piloto'
	},
	{
		id: 'UP',
		label: 'Techo'
	}
];

export const REJECTED_REASONS = [
	{
		id: '001',
		label: 'Tarjeta no coincide con auto'
	},
	{
		id: '002',
		label: 'Daños graves'
	},
	{
		id: '003',
		label: 'Tiene jaula'
	},
	{
		id: '004',
		label: 'Kilometraje mayor a 300,000'
	},
	{
		id: '005',
		label: 'Uso no declarado'
	},
	{
		id: '006',
		label: 'Timón cambiado'
	},
	{
		id: '007',
		label: 'Versión coreana / americana'
	},
	{
		id: '008',
		label: 'Ha sido pérdida total'
	},
	{
		id: '009',
		label: 'No asegurable'
	}
];



// WEBPACK FOOTER //
// ./src/constants/app/inspection.js